<template>
  <div class='massLoss-list'>
    <div class='tabs'>
      <div @click='typeFun(0)' class='left' :class='{ active: dateType === 0 }'>月度</div>
      <div @click='typeFun(1)' class='right' :class='{ active: dateType === 1 }'>年度</div>
    </div>

    <div class='componentsContainer'>
      <month v-if='dateType === 0' ref='monthRef' />
      <year v-else-if='dateType === 1' ref='yearRef' />
    </div>
  </div>
</template>

<script>
  import Month from './components/month.vue';
  import Year from './components/year.vue';

  export default {
    name: 'yearAndMonthReport',
    components: {
      Year,
      Month,
    },
    data() {
      return {
        dateType: 0,
      };
    },
    methods: {
      // 月度/年度 切换
      typeFun(val) {
        this.dateType = val;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    width: 100%;
    padding: 20px 15px 0 25px;
    display: flex;
    flex-direction: column;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 240px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .componentsContainer {
      width: 100%;

      .electrify {
        padding: 0;
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }
</style>
